import { combineReducers } from 'redux';
import jobs from './reducer-jobs';
import user from './reducer-user';
import addJob from './reducer-addJob'
import singleJob from './reducer-singleJob';
import form from './reducer-form';
import feedback from './reducer-feedback';
import logs from './reducer-logs';
import reports from './reducer-reports';
import importJobs from './reducer-importJob';
import actionMode from './reducer-actionMode';
import comments from './reducer-conversation';

const rootReducer = combineReducers({
  addJob,
  jobs,
  user,
  singleJob,
  form,
  feedback,
  logs,
  comments,
  reports,
  importJobs,
  actionMode,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js